import { ApiAuth } from "@/api/auth";
import { useMutation } from "@tanstack/react-query";
import { ModalStateType } from "../types";
import { AuthRegistrationResource } from "@/api/generated-api";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { REGISTER_FORM_SCHEMA } from "../components/register/constants";
import { useState } from "react";

export const useRegisterData = ({ state }: { state: Exclude<ModalStateType, "login"> }) => {
  const [lastPayload, setLastPayload] = useState<AuthRegistrationResource | null>(null);

  const methods = useForm<AuthRegistrationResource>({
    resolver: zodResolver(REGISTER_FORM_SCHEMA),
    defaultValues: {
      email: "",
      password: "",
      password_confirmation: "",
    },
    mode: "onSubmit",
    reValidateMode: "onChange",
  });

  const { mutate, isPending, isError, isSuccess, reset, error } = useMutation({
    mutationFn: (data: AuthRegistrationResource) =>
      state === "register" ? ApiAuth.registration(data) : ApiAuth.resetPassword(data),
  });

  const onSubmit = methods.handleSubmit(data => {
    setLastPayload(data);
    mutate(data);
  });

  const handleBackToForm = () => {
    reset();
    setLastPayload(null);
  };

  return { onSubmit, handleBackToForm, lastPayload, isPending, isError, isSuccess, methods, error };
};
